"use client"

import Link from "next/link"
import { Linkedin, Twitter, Facebook } from "lucide-react"
import { Logo } from "@/components/logo"
import { useLanguage } from "@/contexts/language-context"
import { SmartAnchorLink } from "@/components/smart-anchor-link"

export function Footer() {
  const { t, currentLanguage } = useLanguage();
  
  // 根据当前语言决定Logo尺寸
  const logoWidth = currentLanguage === "zh-cn" || currentLanguage === "zh-tw" ? 140 : 160;
  
  return (
    <footer id="contact" className="bg-white dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-700">
      <div className="container px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link href="/" className="flex items-center space-x-2">
              <Logo width={logoWidth} height={50} inFooter={true} />
            </Link>
            <p className="text-gray-600 dark:text-gray-300">{t("main.title")}</p>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-900 dark:text-white">{t("footer.product")}</h3>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
              <li>
                <SmartAnchorLink href="#features" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("nav.features")}
                </SmartAnchorLink>
              </li>
              <li>
                <SmartAnchorLink href="#pricing" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("nav.pricing")}
                </SmartAnchorLink>
              </li>
              <li>
                <SmartAnchorLink href="#how-it-works" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("nav.howItWorks")}
                </SmartAnchorLink>
              </li>
              <li>
                <Link href="/showcase" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("nav.testimonials")}
                </Link>
              </li>
              <li>
                <SmartAnchorLink href="#faq" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("nav.faq")}
                </SmartAnchorLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-900 dark:text-white">{t("footer.support")}</h3>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
              <li>
                <Link href="mailto:support@communicate2win.com" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.contactSupport")}
                </Link>
              </li>
              {/* <li>
                <Link href="#" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.helpCenter")}
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.apiDocs")}
                </Link>
              </li>
              <li>
                <Link href="#" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.statusPage")}
                </Link>
              </li> */}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-gray-900 dark:text-white">{t("footer.legal")}</h3>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
              <li>
                <Link href="/privacy-policy" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.privacyPolicy")}
                </Link>
              </li>
              <li>
                <Link href="/terms-of-service" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.termsOfService")}
                </Link>
              </li>
              <li>
                <Link href="/cookie-policy" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.cookiePolicy")}
                </Link>
              </li>
              <li>
                <Link href="/refund-policy" className="hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                  {t("footer.refundPolicy")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-zinc-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-600 dark:text-gray-300">{t("footer.copyright")}</p>

          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {t("footer.supportLabel")}:{" "}
              <Link href="mailto:support@communicate2win.com" className="text-blue-600 dark:text-indigo-400 hover:text-blue-700 dark:hover:text-indigo-300 transition-colors">
                support@communicate2win.com
              </Link>
            </p>
            {/* <div className="flex space-x-2">
              <Link href="#" className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </Link>
              <Link href="#" className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </Link>
              <Link href="#" className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-indigo-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  )
}
